//Comentario necesario para codificación en UTF-8, ver Inc6743
(function() {
	var App = angular.module('pphhApp');

	App.service("historyActionController", ["$window", "pphhEnv", HistoryActionController]);

	function HistoryActionController($window, pphhEnv) {
		this.performAction = performAction;

		function performAction(scope, row) {
			if (scope.currentActivity == null) {
				$window.open(pphhEnv.global.contextPath + "/pphhNav/crud/" + scope.entity.entityName + "/" + row.id + "/historial");
			}
		}
	}
})();